import React from 'react';
import { ArrowRightIcon, CalendarIcon } from 'lucide-react';
export function BlogSection() {
  const articles = [{
    title: 'Kosten website laten maken',
    description: 'Wat kost een professionele website in 2026? Wij zetten de prijzen op een rij en leggen uit waar je op moet letten.',
    date: '15 feb 2026',
    slug: '#/kosten-website-laten-maken',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop'
  }, {
    title: 'Website laten maken checklist',
    description: 'Alles wat je moet weten voordat je een website laat maken. Van domeinnaam tot content: deze checklist helpt je op weg.',
    date: '8 feb 2026',
    slug: '#/website-laten-maken-checklist',
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=600&h=400&fit=crop'
  }, {
    title: 'WordPress vs Wix',
    description: 'Welk platform past het beste bij jouw bedrijf? We vergelijken WordPress en Wix op prijs, flexibiliteit en SEO.',
    date: '1 feb 2026',
    slug: '#/wordpress-vs-wix',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop'
  }];
  return <section id="kennisbank" className="py-24 lg:py-28 bg-surface-muted" data-id="element-267" data-mp="151hghhc5qofn">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-268" data-mp="108eubu9pmh9h">
        <div className="text-center mb-12 lg:mb-16" data-id="element-269" data-mp="1ey4248cb5jiq">
          {/* Norden portrait as section mascot */}
          <div className="w-16 h-16 rounded-full bg-accent-light border-2 border-accent/20 flex items-center justify-center mx-auto mb-5 overflow-hidden" data-id="element-270" data-mp="19zsr3uaa12yx">
            <img src="https://cdn.magicpatterns.com/uploads/iiZ1GezbBxoz115PhFt8o5/Norden_portret_formulier_300dpi.png" alt="Norden mascotte" className="w-12 h-12 object-cover object-top" data-id="element-271" data-mp="1ny95m7edrxrm" />
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-272" data-mp="3lplj8b85hzz7">
            Laatste kennisbank artikelen
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-273" data-mp="1oq0mrzbvy4ph">
            Tips en inzichten over webdesign, SEO en online groeien als
            ondernemer in Alkmaar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-274" data-mp="1yl2bwv65v6s2">
          {articles.map(article => <a key={article.title} href={article.slug} className="group bg-white rounded-card overflow-hidden shadow-card hover:shadow-medium transition-all duration-300" data-id="element-275" data-mp="23jdjt0cwb77n">
              {/* Image */}
              <div className="aspect-[16/10] overflow-hidden" data-id="element-276" data-mp="2hclfb343kmum">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-277" data-mp="2mby967tdyu6p" />
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-278" data-mp="2vajprxfarz4u">
                <div className="flex items-center gap-2 text-xs text-slate-400 mb-3" data-id="element-279" data-mp="jpslkotdwwlc">
                  <CalendarIcon className="w-3.5 h-3.5" data-id="element-280" data-mp="fnpc25qa022p" />
                  {article.date}
                </div>
                <h3 className="text-lg font-bold text-navy-900 mb-2 group-hover:text-accent transition-colors" data-id="element-281" data-mp="ao2ujk3ezzo3">
                  {article.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4" data-id="element-282" data-mp="5rulmoft92pd">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all" data-id="element-283" data-mp="ydni6gaijl3p">
                  Lees meer
                  <ArrowRightIcon className="w-4 h-4" data-id="element-284" data-mp="tl43th404lxu" />
                </span>
              </div>
            </a>)}
        </div>

        <div className="mt-12 text-center" data-id="element-285" data-mp="1m419u5p6rhxr">
          <a href="#/kennisbank" className="inline-flex items-center gap-2 text-accent hover:text-accent-hover font-semibold transition-colors group" data-id="element-286" data-mp="1m52pknh5cslt">
            Bekijk alle artikelen
            <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" data-id="element-287" data-mp="15wn039lm3oem" />
          </a>
        </div>
      </div>
    </section>;
}